import React from 'react';
import '../styles/ProBadge.css';

export default function ProBadge({ tooltip = "Upgrade to unlock this feature in your current plan" }) {
  return (
    <span className="pro-badge-inline" title={tooltip}>
      PRO
    </span>
  );
}
